import { api } from "../../client";

export const couponServices = {
  verifyCoupon(model) {
    return api.base.post("coupon/verify",model);
  },

};
